'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isParametersMatchChapterConfig = exports.isParametersTypeRight = exports.isChapterConfigRequireFieldsAllDone = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _error = require('./error');

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isChapterConfigRequireFieldsAllDone = exports.isChapterConfigRequireFieldsAllDone = function isChapterConfigRequireFieldsAllDone(chapter) {
  if (!chapter.hasOwnProperty('url')) {
    throw _error2.default[1];
  }
  if (!chapter.hasOwnProperty('method')) {
    throw _error2.default[2];
  } else {}
  return true;
};

var isParametersTypeRight = exports.isParametersTypeRight = function isParametersTypeRight(parameters) {
  switch (typeof parameters === 'undefined' ? 'undefined' : _typeof(parameters)) {
    case 'string':
      return false;
    case 'number':
      return false;
    default:
      return true;
  }
};

var isParametersMatchChapterConfig = exports.isParametersMatchChapterConfig = function isParametersMatchChapterConfig(chapter, parameters) {
  // console.log(chapter)
  return true;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/api-book/lib/validation.js
// module id = 507
// module chunks = 0